export default __webpack_public_path__ + "static/media/grid2.d00b6f24.png";